<template>
  <v-list dense nav class="px-0">
    <div class="px-2">
      <v-list-item
        v-for="(item, i) in itens_pesquisa_satisfacao"
        :key="i"
        :href="item.href"
        target="_blank"
        @click="redirect(item.way, $event)"
        :class="isActive(item.way)"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-icon>
              <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                item.icon
              }}</v-icon>
            </v-list-item-icon>
          </template>
          <span>{{ item.message }}</span>
        </v-tooltip>
        <v-list-item-title class="ml-n4">{{ item.title }}</v-list-item-title>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";
import { goToSelectedPath } from "@/utils/commomMethods/goToSelectedPath";

import {
  permissoesCadastroPesquisa,
  permissoesRelatoriosPesquisa,
} from "../utils/permissoesPesquisaSatisfacao";

export default {
  name: "ListNavigationDrawerSatisfactionResearch",
  props: {
    drawer: Boolean,
  },
  data: () => ({
    rotaSelecionada: "",
    itens_pesquisa_satisfacao: [],
    permissionRelatorioPesquisa: false,
    permissionCadastroPesquisa: false,
  }),

  created() {
    const arrayPermissions = this.arrayPermissionsFromLocalStorage();

    arrayPermissions.forEach((pemrissionLocalStorage) => {
      if (
        permissoesCadastroPesquisa.includes(pemrissionLocalStorage) &&
        !this.permissionCadastroPesquisa
      ) {
        this.permissionCadastroPesquisa = true;
        this.itens_pesquisa_satisfacao.push({
          title: "Cadastro de Pesquisa",
          way: "cadastroPesquisa",
          icon: "mdi-file-find",
          message: "Cadastro de Pesquisa",
          href: "/pesquisa-satisfacao/cadastro/pesquisa-satisfacao",
        });
      }
      if (
        permissoesRelatoriosPesquisa.includes(pemrissionLocalStorage) &&
        !this.permissionRelatorioPesquisa
      ) {
        this.permissionRelatorioPesquisa = true;
        this.itens_pesquisa_satisfacao.push({
          title: "Relatórios de Pesquisa",
          way: "relatorioPesquisa",
          icon: "mdi-chart-donut",
          message: "Relatórios de Pesquisa",
          href: "/pesquisa-satisfacao/relatorios/pesquisa-satisfacao",
        });
      }
    });
  },

  methods: {
    ...goToSelectedPath,
    ...obtainUserPermissions,
    isActive(rota) {
      if (rota == this.$route.name) {
        this.rotaSelecionada = rota
        return "indigo lighten-5";
      } else if (rota == this.rotaSelecionada) {
        return "indigo lighten-5";
      }
    },
  },
};
</script>
